import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M23.67,7.4a.51.51,0,0,0,0-.7L17.3.33a.5.5,0,0,0-.7,0l-1,1a.25.25,0,0,0,0,.36L16.79,3a.5.5,0,0,1,0,.71.48.48,0,0,1-.7,0L14.85,2.43a.29.29,0,0,0-.18-.07.26.26,0,0,0-.17.07l-.71.71a.25.25,0,0,0-.08.18.27.27,0,0,0,.08.18L15,4.73a.5.5,0,1,1-.71.71L13.08,4.2a.24.24,0,0,0-.35,0L12,4.91a.24.24,0,0,0,0,.35L13.26,6.5a.5.5,0,1,1-.71.71L11.31,6a.22.22,0,0,0-.17-.07A.24.24,0,0,0,11,6L9.53,7.4a.51.51,0,0,0-.15.36.47.47,0,0,0,.15.35l.35.35a1,1,0,0,1,0,1.42,1,1,0,0,1-1.42,0l-.35-.35a.5.5,0,0,0-.71,0L6,10.92a.24.24,0,0,0-.07.18.22.22,0,0,0,.07.17l1.24,1.24a.5.5,0,0,1-.71.71L5.3,12A.24.24,0,0,0,5,12l-.71.71a.25.25,0,0,0,0,.35l1.24,1.24a.5.5,0,0,1-.71.71L3.54,13.75a.27.27,0,0,0-.36,0l-.71.71a.26.26,0,0,0,0,.35l1.24,1.24a.48.48,0,0,1,0,.7.5.5,0,0,1-.71,0L1.77,15.52a.25.25,0,0,0-.36,0L.33,16.6a.51.51,0,0,0,0,.7L6.7,23.67a.51.51,0,0,0,.7,0Zm-6-1.76a1,1,0,0,1,1.41,0l.71.7a1,1,0,0,1,0,1.42L17.66,9.88a1,1,0,0,1-1.42,0l-.7-.71a1,1,0,0,1,0-1.41Zm-12,12,2.12-2.12a1,1,0,0,1,1.41,0l.71.7a1,1,0,0,1,0,1.42L7.76,19.78a1,1,0,0,1-1.42,0l-.7-.71A1,1,0,0,1,5.64,17.66Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }